module.exports = __webpack_public_path__ + "img/2016_S.2b202737.png";